import { useState } from "react";
import { toast } from "sonner";
import { Mail, Send, X, Lock } from "lucide-react";
import { api } from "@/lib/api";

export default function ContactModal({ open, onClose }) {
  const [form, setForm] = useState({ name: "", contact: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!form.message.trim() || form.message.trim().length < 3) {
      toast.error("Écris quelques mots, je lirai.");
      return;
    }
    try {
      setSubmitting(true);
      await api.post("/contact", form);
      toast.success("Message envoyé — je te lis en priorité.");
      setForm({ name: "", contact: "", message: "" });
      onClose();
    } catch {
      toast.error("Envoi impossible pour l'instant.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[80] bg-black/70 backdrop-blur-sm grid place-items-center p-5"
      data-testid="contact-modal"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="em-card w-full max-w-lg p-6 lg:p-8">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-xl bg-orange-500/15 border border-orange-500/30 grid place-items-center">
              <Mail className="w-5 h-5 text-orange-300" />
            </div>
            <div>
              <h3 className="text-xl font-semibold text-white font-[Outfit]">Me contacter en privé</h3>
              <p className="text-sm text-slate-400">Un message pour le créateur du site (Marwane M.).</p>
            </div>
          </div>
          <button onClick={onClose} aria-label="Fermer" className="p-2 rounded-full hover:bg-white/10">
            <X className="w-4 h-4 text-slate-300" />
          </button>
        </div>

        <form onSubmit={submit} className="mt-5 grid gap-3" data-testid="contact-form">
          <div className="grid md:grid-cols-2 gap-3">
            <input
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Prénom ou pseudo (facultatif)"
              data-testid="contact-name"
              className="bg-white/5 border border-white/10 rounded-2xl px-4 py-3 text-white placeholder:text-slate-500"
              maxLength={60}
            />
            <input
              value={form.contact}
              onChange={(e) => setForm({ ...form, contact: e.target.value })}
              placeholder="Email / Discord (facultatif)"
              data-testid="contact-contact"
              className="bg-white/5 border border-white/10 rounded-2xl px-4 py-3 text-white placeholder:text-slate-500"
              maxLength={150}
            />
          </div>
          <textarea
            rows={5}
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            placeholder="Ton message… Suggestions, bug, besoin d'écoute, idées de fonctionnalités."
            data-testid="contact-message"
            className="bg-white/5 border border-white/10 rounded-2xl px-4 py-3 text-white placeholder:text-slate-500"
            maxLength={4000}
            required
          />
          <p className="text-xs text-slate-500 flex items-center gap-2">
            <Lock className="w-3.5 h-3.5" />
            Message privé — lu uniquement par Marwane M. depuis son panneau admin.
          </p>
          <button
            type="submit"
            disabled={submitting}
            data-testid="contact-submit"
            className="inline-flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 disabled:opacity-60 text-white font-semibold px-5 py-3 rounded-full"
          >
            <Send className="w-4 h-4" />
            {submitting ? "Envoi…" : "Envoyer en privé"}
          </button>
        </form>
      </div>
    </div>
  );
}
